import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";

/**
 * @function urlIsAKalturaAddress Returns whether the URL is a Kaltura address
 * @param url
 */
export const urlIsAKalturaAddress: (url: string) => boolean = (url: string) => {

  // get the regular expression pattern for the website
  const regEx: RegExp = RegularExpressions.Kaltura;

  // return the result of testing the given url against the regex pattern
  return regEx.test(url);
}
